import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StatusPanel } from "@/components/ui/status-panel";
import { getAppVersionCoordinator } from "@/lib/app-version-coordinator";

export function ApplicationVersionErrorFallback() {
  const reloadApplication = () => {
    const coordinator = getAppVersionCoordinator();
    if (coordinator) {
      coordinator.requestManualReload();
      return;
    }
    window.location.reload();
  };

  return (
    <StatusPanel
      role="alert"
      tone="info"
      icon={RefreshCw}
      className="flex-1"
      title="The application needs to load the current version."
      description="Reload the application to continue. Your saved work will remain available."
      actions={
        <Button type="button" onClick={reloadApplication}>
          <RefreshCw data-icon="inline-start" />
          Reload application
        </Button>
      }
    />
  );
}
